module.exports = __webpack_public_path__ + "img/side_seam_pocket_position.dc4b3c8d.png";